export const HEARD_ABOUT_OPTIONS = [
  'webinar',
  'youtube',
  'facebook_group',
  'facebook_instagram_ad',
  'google_search',
  'ai_chat',
  'newsletter',
  'seller_referral',
  'partner_referral',
  'other',
] as const

export type HeardAboutOption = (typeof HEARD_ABOUT_OPTIONS)[number]

export const HEARD_ABOUT_OTHER = 'other'
